import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var NudgeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22522 7.71633L3.22523 7.71635L3.22683 7.71553C3.39263 7.98639 3.74179 8.08789 4.02922 7.94084C4.33088 7.78651 4.45031 7.41686 4.29598 7.1152C4.28792 7.09944 4.27926 7.08418 4.27006 7.06942C3.70563 5.85087 4.20072 4.39369 5.40682 3.77665C6.61287 3.15962 8.08421 3.61068 8.74217 4.78131C8.74876 4.79745 8.7561 4.81343 8.76418 4.82923C8.91851 5.13089 9.28816 5.25032 9.58981 5.09599C9.87724 4.94894 9.99923 4.6064 9.87659 4.31346L9.87819 4.31264L9.88207 4.32021L9.87819 4.31262L9.86267 4.28261L9.85657 4.27036C9.85164 4.26073 9.84649 4.25128 9.84113 4.24202C8.88022 2.45695 6.6633 1.76021 4.84985 2.68799C3.03651 3.61571 2.30436 5.82099 3.18949 7.64464C3.19391 7.65452 3.19861 7.66434 3.20359 7.67408L3.21013 7.68652L3.22522 7.71633ZM14.3972 14.9339C14.5454 14.8886 14.6358 14.7542 14.6737 14.6331C14.9694 12.1244 14.6632 11.1492 14.23 9.76928C14.1864 9.63051 14.1415 9.48765 14.0959 9.33872C13.8093 8.40394 13.3839 7.77516 12.5538 7.75257C11.9187 7.73529 11.0935 8.08085 9.89421 8.58309C9.8202 8.61409 9.74477 8.64568 9.66787 8.67781C9.63786 8.68582 9.60764 8.69421 9.5774 8.70262C9.27458 8.78676 8.96941 8.87155 8.85276 8.56767C8.72314 8.23275 7.66075 6.16345 7.45928 5.79266C7.25781 5.42186 6.90625 4.93749 6.31373 5.19786C5.90242 5.3786 5.82442 5.92257 5.968 6.29509C6.11158 6.66761 7.22149 9.44836 7.22149 9.44836C7.46708 10.0861 7.66834 10.5696 7.82176 10.9382C8.13801 11.6979 8.25094 11.9692 8.12965 12.0967C7.94356 12.2922 6.53362 12.2578 5.63487 12.2358C5.40678 12.2303 5.21161 12.2255 5.07773 12.2255C4.11255 12.2255 3.73824 13.3064 4.46089 13.5913C7.7364 13.9785 9.75276 15.7625 9.96946 15.9623C10.1117 16.0939 10.3284 16.158 10.6402 16.0709C10.7492 16.041 14.2902 14.9666 14.3972 14.9339Z"
  }));
});
NudgeIcon.displayName = 'NudgeIcon';
export default NudgeIcon;